import React, { Component } from 'react'; //Fragment
import FormFieldBottom from './field-bottom';

export default class CheckboxField extends Component {
    render() {
        const { input, label, meta, note, correct } = this.props;
        const hasError = meta.touched && meta.error;

        return (
            <div className='form-field'>
                <label className="checkbox-field">
                    <input
                        {...input}
                        type="checkbox"
                        className="checkbox-field__input"
                        checked={!!input.value} // Ensure boolean value
                    />
                    <span className="checkbox-field__control" />
                    <span className="checkbox-field__label">{label}</span>
                </label>

                {hasError && <FormFieldBottom meta={meta} note={note} correct={correct} />}
            </div>
        );
    }
}
